"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ObjectEditorFactory_1 = require("./ObjectEditorFactory");
const StringEditorFactory_1 = require("./StringEditorFactory");
const ArrayEditorFactory_1 = require("./ArrayEditorFactory");
const NumberEditorFactory_1 = require("./NumberEditorFactory");
const MapEditorFactory_1 = require("./MapEditorFactory");
const BooleanEditorFactory_1 = require("./BooleanEditorFactory");
exports.defaultFactories = [
    new ObjectEditorFactory_1.ObjectEditorFactory(),
    new ArrayEditorFactory_1.ArrayEditorFactory(),
    new MapEditorFactory_1.MapEditorFactory(),
    new StringEditorFactory_1.StringEditorFactory(),
    new NumberEditorFactory_1.NumberEditorFactory(),
    new BooleanEditorFactory_1.BooleanEditorFactory()
];
//# sourceMappingURL=index.js.map